// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"56d794ad","212":"06b3ed9a","246":"41d235f7","376":"9b8a6035","483":"d80cfe8a","775":"11cdea99","970":"844ce904"}[chunkId] + ".chunk.js";
};